<template>
  <el-table-column
    prop="minimum_price"
    sortable="custom"
    label="Padló ár"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.minimum_price">{{ scope.row.minimum_price | currency }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'minimum_price',
  };
</script>
